import jwt_decode from "jwt-decode";
import {getToken} from "../utils/common";

export enum UserRole {
    ADMIN = "ADMIN",
    DOCTOR = "DOCTOR",
    OBSERVER = "OBSERVER"
}

export type JwtPayload = {
    role: UserRole,
    username: string,
    userid?: string,
    roleEnableScan: boolean,
    roleEnableFileUpload: boolean
}

export const getRole = (): string => {
    return (jwt_decode(getToken()) as JwtPayload).role;
}

export const hasRole = (...requiredRoles: UserRole[]): boolean => {
    const role = getRole();
    return !!requiredRoles.find(x => x === role);
}
